
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1ezv7_66",
  "button": "awsui_button_vjswe_1ezv7_70",
  "variant-normal": "awsui_variant-normal_vjswe_1ezv7_132",
  "disabled": "awsui_disabled_vjswe_1ezv7_150",
  "variant-primary": "awsui_variant-primary_vjswe_1ezv7_157",
  "variant-link": "awsui_variant-link_vjswe_1ezv7_182",
  "variant-icon": "awsui_variant-icon_vjswe_1ezv7_207",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_1ezv7_232",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1ezv7_259",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_1ezv7_284",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1ezv7_309",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1ezv7_338",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1ezv7_363",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1ezv7_388",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1ezv7_418",
  "button-no-text": "awsui_button-no-text_vjswe_1ezv7_516",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1ezv7_520",
  "full-width": "awsui_full-width_vjswe_1ezv7_523",
  "button-compact": "awsui_button-compact_vjswe_1ezv7_540",
  "icon-left": "awsui_icon-left_vjswe_1ezv7_563",
  "icon-right": "awsui_icon-right_vjswe_1ezv7_568",
  "icon": "awsui_icon_vjswe_1ezv7_563",
  "link": "awsui_link_vjswe_1ezv7_587",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1ezv7_587"
};
  